import React from 'react'
import isEqual from 'lodash/isEqual'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { useMutation, useQuery } from 'components/graphql'

import { ImageUploaderInForm } from 'components/Image'
import Divider from 'components/Divider'

import { ColorPicker, Checkbox, Form, Text } from 'components/forms'

import { StyledContentBlock, Label } from './styled'
import getVirtualCardConfig from '../../gql/getVirtualCardConfig'
import updateVirtualCardConfig from '../../gql/updateVirtualCardConfig'
import AppleModalPreview from './AppleModalPreview'
import GoogleModalPreview from './GoogleModalPreview'

const VirtualCards = ({ appData }) => {
	const { data, loading } = useQuery(getVirtualCardConfig)
	const [updateVirtualCard] = useMutation(updateVirtualCardConfig)
	const [t] = useTranslation()
	const formData = data?.getVirtualCardConfig || {}

	const handleSubmit = fields => {
		const newFields = Object.keys(fields).reduce((acc, key) => {
			if(!isEqual(formData[key], fields[key])) {
				acc[key] = fields[key]
			}
			return acc
		}, {})
		updateVirtualCard({ variables: { fields: newFields } })
	}

	return(
		<StyledContentBlock isLoading={loading} imgBackground={formData?.backgroundColor}>
			<Form initialValues={formData} onSubmit={handleSubmit} smartSubmit>
				<Row>
					<Col xs>
						<Checkbox field='isActive' label={t('options_section.fields.vcard_isactive')}/>
						<Text field='issuerName' label={t('options_section.fields.company_name')}/>
						<Text field='issuerEmail' label={t('options_section.fields.vcard_issuerEmail')}/>
						<Text field='programName' label={t('common.fields.name')}/>
						<Text field='accountIdLabel' label={t('options_section.fields.vcard_description')}/>

						<Text field='rewardsTierLabel' label={t('options_section.fields.vcard_fieldtitle', { number: 1 })}/>
						<Text field='rewardsTier' label={t('options_section.fields.vcard_fieldvalue', { number: 1 })}/>
						<Text field='secondaryRewardsTierLabel' label={t('options_section.fields.vcard_fieldtitle', { number: 2 })}/>
						<Text field='secondaryRewardsTier' label={t('options_section.fields.vcard_fieldvalue', { number: 2 })}/>

						<Text field='linkPhoneUri.description' label={t('options_section.fields.vcard_phoneDescription')}/>
						<Text field='linkPhoneUri.link' label={t('options_section.fields.vcard_phone')}/>
						<Text field='homepageUri.description' label={t('options_section.fields.vcard_websiteDescription')}/>
						<Text field='homepageUri.link' label={t('options_section.fields.vcard_website')}/>

						<div style={{ width: '150px' }}>
							<ImageUploaderInForm
								field='logoImg'
								label={t('options_section.fields.vcard_companylogo')}
								width={1200}
								height={1200}
								isRound
								canRemove={false}
								canDownload={false}
								elementMaxWidth={150}
								allowedFileTypes={['image/png']}
							/>
						</div>
						<Divider/>

						<ColorPicker field='backgroundColor' label={t('options_section.fields.vcard_backgroundcolor')} immidiateSubmit/>
					</Col>
					<Col xs={4}>
						<Label underline>{t('options_section.strings.wallet_google')}</Label>
						<Divider/>
						<ImageUploaderInForm
							field='wideLogoGoogleImg'
							label={t('options_section.fields.vcard_widecompanylogo')}
							width={1280}
							height={400}
							elementMaxWidth={370}
							allowedFileTypes={['image/png']}
						/>
						<Divider/>
						<ImageUploaderInForm
							field='heroGoogleImg'
							label={t('options_section.fields.vcard_heroimage')}
							width={1032}
							height={336}
							elementMaxWidth={420}
							allowedFileTypes={['image/png']}
						/>
						<Divider/>
						<GoogleModalPreview formData={formData} appData={appData}/>
					</Col>
					<Col xs={3}>
						<Label underline>{t('options_section.strings.wallet_apple')}</Label>
						<Divider/>
						<ImageUploaderInForm
							field='wideLogoImg'
							label={t('options_section.fields.vcard_widecompanylogo')}
							width={480}
							height={150}
							elementMaxWidth={320}
							allowedFileTypes={['image/png']}
							style={{
								background: '#000'
							}}
						/>
						<Divider/>
						<ColorPicker field='foregroundColor' label={t('options_section.fields.vcard_foregroundColor')} immidiateSubmit/>
						<Divider/>
						<ColorPicker field='labelColor' label={t('options_section.fields.vcard_labelColor')} immidiateSubmit/>
						<Divider/>
						<AppleModalPreview formData={formData} appData={appData}/>
					</Col>
				</Row>
			</Form>
		</StyledContentBlock>
	)
}

export default VirtualCards


